var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as _ from 'lodash';
import { ADD_USERS, REMOVE_USER, RESET_USERS, SET_USERS_LOADING } from '@Actions/usersActions';
export const defaultState = {
    users: [],
    usersLoading: false,
    usersActiveOrInvited: [],
    usersById: {}
};
export const usersReducer = function (state = defaultState, action) {
    switch (action.type) {
        case ADD_USERS: {
            const users = _.uniqBy([...action.users, ...state.users], (user) => user.id).map((user) => {
                user.displayName = user.name || user.email;
                return user;
            });
            const usersActiveOrInvited = users.filter((user) => (user.is_active || user.is_invited) && user.user_profile.is_active_or_invited);
            const usersById = _.keyBy(users, 'id');
            return _.assign({}, state, {
                users,
                usersActiveOrInvited,
                usersById
            });
        }
        case REMOVE_USER: {
            const _a = state.usersById, _b = action.user.id, removedUser = _a[_b], newUsersByIdState = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return Object.assign(Object.assign({}, state), { users: state.users.filter((user) => user.id !== action.user.id), usersActiveOrInvited: state.usersActiveOrInvited.filter((user) => user.id !== action.user.id), usersById: newUsersByIdState });
        }
        case SET_USERS_LOADING:
            return Object.assign(Object.assign({}, state), { usersLoading: action.payload });
        case RESET_USERS:
            return Object.assign({}, defaultState);
        default:
            return state;
    }
};
